// Shared storage contract with backend/user_data_keys.py. Entitlements never enter this list.
export const USER_DATA_KEYS = new Set([
  'user_profile', 'training_records', 'weight_records', 'daily_health_records',
  'diet_plans', 'current_diet_plan_id', 'custom_plan', 'body_signals',
  'member_training_plan', 'injury_recovery_plan', 'injury_recovery_completed_dates',
  'aerobic_completed_dates', 'food_usage_stats', 'diet_saved_meals_v1', 'conversion_track',
  'daily_reminder_settings', 'training_timer_settings', 'training_timer_settings_v',
  'custom_training_plans', 'custom_selected_ids', 'active_workout',
  'cycle_compare_photos_v2', 'detailed_assessment_draft', 'my_training_plan_v1',
  'training_active_tab', 'fen_jue_active_project', 'fen_jue_plan_bench_v1', 'fen_jue_plan_squat_v1',
  'training_cycle',
]);
const dateKey = /^(diet_checkin_|diet_actual_)(\d{4}-\d{2}-\d{2}|(?:Sun|Mon|Tue|Wed|Thu|Fri|Sat) (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{2} \d{4})$/;
export function isUserDataKey(key: string): boolean {
  return USER_DATA_KEYS.has(key) || dateKey.test(key)
    || /^(exercise_order_|exercise_removed_)[A-Za-z0-9_-]{1,96}$/.test(key);
}

export interface CloudItem { value: string | null; revision: number; updatedAt: number }
export interface CloudSnapshot { revision: number; items: Record<string, CloudItem> }
export interface SyncChange { key: string; value: string | null; baseRevision: number }
export interface SyncRequest { requestId: string; changes: SyncChange[] }
export const emptyCloudItem = (): CloudItem => ({ value: null, revision: 0, updatedAt: 0 });
